import { useLocation, Link } from 'react-router-dom';
import Styles from './navbar.module.scss';

export const Navbar = () => {
	const location = useLocation();

	const links = [
		{ path: '/', label: 'Welcome' },
		{ path: '/menu', label: 'Menu' },
	];

	return (
		<nav className={Styles.navbar}>
			<div className={Styles.navLinks}>
				{links.map((link) => (
					<Link
						key={link.path}
						to={link.path}
						className={`${Styles.navButton} ${location.pathname === link.path ? Styles.selected : ''}`}
					>
						{link.label}
					</Link>
				))}
			</div>
		</nav>
	);
};
